export const navigationCustomizations = {
  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderRadius: '0 8px 8px 0',
      },
    },
  },
};
